import { HttpHandler } from 'msw'

import { all } from './all'
import { diagnostics } from './diagnostics'
import { distributors } from './distributors'
import { lockers } from './lockers'
import { machineRelations } from './machineRelations'
import { microwaves } from './microwaves'
import { planograms } from './planograms'
import { terminals } from './terminals'

export const machines: HttpHandler[] = [
    ...all,
    ...diagnostics,
    ...distributors,
    ...lockers,
    ...machineRelations,
    ...microwaves,
    ...planograms,
    ...terminals,
]
